import type { Commit } from 'vuex';

interface State {
  isModalShown: boolean;
}

const state = (): State => ({
  isModalShown: false,
});

const actions = {
  toggleModal({ commit }: { commit: Commit }, isShown: boolean) {
    commit('TOGGLE_MODAL', isShown);
  },
};

const mutations = {
  TOGGLE_MODAL(state: State, isShown: boolean) {
    state.isModalShown = isShown;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
